export default {
  "slot-selection": "Select slot",
  "slot-selection.all": "All",
  "slot-selection.empty": "There are no dates available",
  "slot-selection.type": "Appointment type",
  "slot-selection.time": "Gewünschte Tageszeit",
  "slot-selection.select-date": "Select date",
  "slot-selection.select-slot": "Select time",
  "slot-selection.selected-slot": "Selected slot",
  "slot-selection.selected-slot.clinic": "Clinic",
  "slot-selection.selected-slot.patient": "Patient",
  "slot-selection.go-to-confirmation": "Continue to confirmation",
  "slot-selection.select-type": "Please select an appointment type to continue",

  "slot-selection.selected-slot.unit": "Facility",
  "slot-selection.selected-slot.date-time": "Date / Time",
  "slot-selection.selected-slot.time": "Time",
  "slot-selection.selected-slot.location": "Location",
  "slot-selection.selected-slot.contact": "Contact",
  "slot-selection.selected-slot.book": "Book appointment",
  "slot-selection.selected-slot.confirmation-title":
    "Confirm appointment booking",
  "slot-selection.selected-slot.confirm-appointment": "Confrim appointment",
  "slot-selection.selected-slot.booking-successful":
    "Your appointment was successfully booked 🎉",
  "slot-selection.selected-slot.booking-successful.automatic":
    "Your appointment request has been automatically confirmed by the clinic and your appointment has been booked.",

  "slot-selection.booking-error":
    "The appointment booking could not be completed",
  "slot-selection.booking-error.message":
    "Please try to select another time slot.",

  "appointment-request.time-frame.details": "Please select the desired period.",
};
